import React from 'react'
import Hero from './Hero'
import AboutSection from './AboutSection'
import MissionSection from './MissionSection'
import ServicesSection from './ServicesSection'
import SkillSection from './SkillSection'
import TeamSection from './TeamSection'
import HowItWorks from './HowItWorks'
import Blog from '../Blog'
import FAQ from '../FAQ'
import ScrollToTop from '../../components/ScrollToTop'
import SEO from '../../components/SEO'

function Home() {
    return (
        <>
            <SEO
                canonical="/"
            />
            {/* <Navbar />/ */}
            <ScrollToTop />
            <Hero />
            <AboutSection />
            <MissionSection />
            <ServicesSection />
            <SkillSection />
            <TeamSection />
            <HowItWorks />
            <Blog isSection={true} />
            <FAQ isSection={true} />

            {/* <Footer /> */}
        </>
    )
}

export default Home
